import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import { FC, ReactNode } from "react";

interface CardWidgetProps {
    icon: ReactNode;
    iconTitle?: string;
    title: string;
    titleAddon?: ReactNode;
    description?: string | ReactNode;
    button?: ReactNode;
    href: string;
    infoHref?: string;
    disabled?: boolean;
}

const CardWidget: FC<CardWidgetProps> = ({
    icon,
    iconTitle,
    title,
    description,
    href,
    button,
    infoHref,
    disabled = false,
    titleAddon,
}) => {
    return (
        <Link
            className="flex items-center gap-6 rounded-widget border border-border-elevated bg-background-elevated p-8 text-text-detail hover:bg-background-elevated-hover"
            href={href}
            aria-disabled={disabled}
        >
            <div className="flex size-24 flex-col items-center justify-center rounded-xl bg-background-elevated-highlight">
                {icon}
                {iconTitle}
            </div>
            <div>
                <span className="flex items-center py-2">
                    <span className="whitespace-pre-wrap text-xl leading-none text-text-heading">
                        {title}
                    </span>
                    {titleAddon && titleAddon}
                </span>
                {description && (
                    <div className="text-base leading-4">{description}</div>
                )}
                {button && <div className="mt-3">{button}</div>}
                {infoHref && (
                    <object>
                        <Link
                            href={infoHref}
                            target="_blank"
                            className="mt-2 flex items-center gap-1 text-sm opacity-80 hover:opacity-100"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <ArrowTopRightOnSquareIcon className="size-3" />
                            <span>{title} guide</span>
                        </Link>
                    </object>
                )}
            </div>
        </Link>
    );
};

export default CardWidget;
